import { Link } from 'react-router';
import { Icon } from '../Icon/Icon';
import { composeExternalLinkAttributes } from '../TextLink/utils';
import { ListItemContent } from './ListItemContent';
import { ListItemProps, listItem, trailingElementWrapper } from './ListTypes';

export const ListItem = ({
  heading,
  body,
  leadingElement,
  headingTag,
  linkTo,
  onClick,
  external,
  trailingIcon = 'chevron_right',
  disabled = false,
  grouping = 'noSeparators',
  width,
  background = 'white',
}: ListItemProps) => {
  const clickable = Boolean(linkTo || onClick);
  const interactive = clickable && !disabled;
  const { target, rel } = composeExternalLinkAttributes({ external });

  const rowContent = (
    <>
      <ListItemContent
        heading={heading}
        body={body}
        leadingElement={leadingElement}
        headingTag={headingTag}
        disabled={disabled}
      />
      {clickable && (
        <div className={trailingElementWrapper({ centered: false })}>
          <Icon name={trailingIcon} label="navigate" />
        </div>
      )}
    </>
  );

  return (
    <li
      className={listItem({
        width: width || 'full',
        disabled,
        background,
        grouping,
        interaction: clickable ? 'active' : undefined,
      })}
    >
      {interactive && linkTo ? (
        <Link
          to={linkTo}
          target={target}
          rel={rel}
          onClick={onClick}
          className="flex gap-s px-s py-xs w-full text-start"
        >
          {rowContent}
        </Link>
      ) : interactive && onClick ? (
        <button
          type="button"
          onClick={onClick}
          className="flex gap-s px-s py-xs w-full text-start"
        >
          {rowContent}
        </button>
      ) : (
        <div aria-disabled={disabled} className="flex gap-s px-s py-xs w-full">
          {rowContent}
        </div>
      )}
    </li>
  );
};
